import React from "react";
import { styled } from '@mui/material/styles';
import footerStyles from './FooterStyles';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LanguageIcon from '@mui/icons-material/Language';

type FooterProps = {

};

const StyledFooter = styled('footer')(({ theme }) => footerStyles);

const Footer: React.FC<FooterProps> = () => {
  return (
    <section className="bg-[#212121] flex items-center justify-center flex-col">
      <div className="container">
        <StyledFooter>
          <div className="footer-links-section">
          <ul>
            <h1 className="footer-link-title">Mapa del sitio</h1>
              <li className="footer-link">
                Servicios
              </li>
              <li className="footer-link">
                Nosotros
              </li>
              <li className="footer-link">
                Contacto
              </li>
          </ul>
          <ul>
            <h1 className="footer-link-title">Contacto</h1>
              <div className="footer-text">
                +52 775 127 4603
              </div>
              <div className="footer-text">
                +52 775 155 8565
              </div>
          </ul>
          <ul>
            <h1 className="footer-link-title">Ubicación</h1>
              <div className="footer-text">
                México Km 60, Santa Gertrudis, 43855 Zempoala, Hgo.
              </div>
          </ul>
          </div>
          <div className="footer-policy-section">
            <span>© 2026 Grupo GM - Renta de cajas secas y plataformas. Todos los derechos reservados.</span>
            <span>Terms · Privacy Policy</span>
            <div>
              <a className="footer-media-button" href="https://www.instagram.com/grupogm.mx" target="_blank" rel="noopener noreferrer">
                <InstagramIcon></InstagramIcon>
              </a>
              <a className="footer-media-button" href="https://www.facebook.com/profile.php?id=61577627324004" target="_blank" rel="noopener noreferrer">
                <FacebookIcon></FacebookIcon>
              </a>
              <a className="footer-media-button" href="https://twitter.com/grupogm_mx" target="_blank" rel="noopener noreferrer">
                <TwitterIcon></TwitterIcon>
              </a>
              <a className="footer-media-button" href="https://blog.grupo-gm.mx" target="_blank" rel="noopener noreferrer">
                <LanguageIcon></LanguageIcon>
              </a>
            </div>
          </div>
        </StyledFooter>
      </div>
    <div className="bg-secondary w-full text-white text-center text-[12px] py-2"><div className="px-4">Privacy Policy | Terms of Use | © 2024 Grupo GM A Division of Grupo GM LLC. All Rights Reserved.</div></div>
    </section>
  );
};

export default Footer;